<template>
  <div class="intell-left" ref="intellLeft">
    <div class="c-header patient-header">
      <div>
        <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
        <span style="white-space: nowrap;">患者信息</span>
      </div>
      <button class="btn btn_newpatient" @click="clearOperation" style="margin-right:5px;">新建</button>
    </div>
    <div calss="intell-left-content" style="height:calc(100% - 42px);overflow-y:auto">
      <div class="patient-info">
        <div class="i-content">
          <el-form
            :model="form"
            ref="form"
            status-icon
            :rules="patientRules"
            size="mini"
            label-width="80px"
            label-position="left"
          >
            <el-form-item label="ID**" prop="id_in_hospital">
              <el-autocomplete
                ref="idInput"
                v-model="form.id_in_hospital"
                :fetch-suggestions="querySearchId"
                :trigger-on-focus="false"
                :disabled="patient_id_disabled || readonly"
                placeholder="请输入ID"
                @select="handleSelectId"
                style="width:85%;"
                @blur="patientForm"
                @input="form.id_in_hospital = form.id_in_hospital.replace(/[\u4e00-\u9fa5]/g, '')"
              ></el-autocomplete>
            </el-form-item>
            <!--<el-form-item label="身份证*" prop="idCardNumber">
  <el-input
    :readonly="readonly"
    v-model="form.idCardNumber"
    placeholder="请输入身份证号"
    type
    style="width:85%;"
    @blur="patientForm"
    :disabled="patient_id_disabled"
    ref="formIdCardNumber"
  ></el-input>
            </el-form-item>-->
            <el-form-item label="姓 名**" prop="name">
              <el-autocomplete
                :disabled="readonly"
                popper-class="my-autocomplete"
                v-model="form.name"
                :fetch-suggestions="querySearch"
                :trigger-on-focus="false"
                placeholder="请输入姓名"
                @select="handleSelect"
                style="width:85%;"
                @blur="patientForm"
                ref="formName"
                @input="form.name = form.name.replace(/\d/g, '')"
              >
                <template slot-scope="{item}" @click="chooseExistPatient" style="width: 500px">
                  <span class="name">{{item.name}}， ID:</span>
                  <span class="phone">{{item.id_in_hospital}}</span>
                  <!-- <div class="address">{{item.address}}</div> -->
                </template>
              </el-autocomplete>
            </el-form-item>
            <div class="patient-wrapper">
              <div class="sex-con">
                <div class="label" style="margin-right: 25%;">性别**</div>
                <div>
                  <el-radio-group
                    :disabled="readonly"
                    change="changeGender"
                    v-model="form.gender"
                    size="mini"
                    style="width:90px;margin-left:16%;height:30px;"
                    @change="patientForm"
                  >
                    <el-radio-button label="男"></el-radio-button>
                    <el-radio-button label="女"></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="race-con">
                <div class="label" style="margin-right: 10%;">年龄*</div>
                <div id="input-box_1">
                  <el-input
                    :disabled="readonly"
                    v-model="form.age"
                    placeholder
                    type
                    size="mini"
                    maxlength="3"
                    style="width:54%;"
                    @input="form.age = form.age.replace(/[^\d]/g, '')"
                    @blur="patientForm"
                  ></el-input>
                  <!--<div style="margin-left:6px;font-size: 14px;line-height: 28px;">岁</div>-->
                </div>
              </div>
            </div>
            <el-form-item label="生日*" prop="birthday" style="margin-top:10px;">
              <el-date-picker
                :disabled="readonly"
                v-model="form.birthday"
                align="right"
                type="date"
                :clearable="false"
                placeholder="年龄或生日选填一项"
                value-format="yyyy-MM-dd"
                default-value="1980-01-01"
                size="small"
                style="width:85%;"
                @blur="patientForm"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input
                :disabled="readonly"
                v-model="form.phone"
                placeholder="请输入手机号"
                type
                maxlength="11"
                style="width:85%;"
                @input="form.phone = form.phone.replace(/[^\d]/g, '')"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证">
              <el-input
                :disabled="readonly"
                v-model="form.idCardNumber"
                placeholder="请输入身份证号"
                type
                style="width:85%;"
                @blur="patientForm"
                maxlength="18"
              ></el-input>
            </el-form-item>
            <el-form-item label="民族" prop="race">
              <el-select
                v-model="form.race"
                placeholder="请选择民族"
                size="mini"
                style="width:85%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in races"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="皮肤类型"  prop="skin_type">
              <el-select
                v-model="form.skin_type"
                placeholder="请选择皮肤类型"
                size="small"
                style="width:85%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in skinOpsType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="肤色" v-if="!patientMore" prop="skin_color">
              <el-select
                v-model="form.skin_color"
                placeholder="请选择肤色"
                size="small"
                style="width:85%;"
                :disabled="readonly"
                @blur="patientForm"
              >
                <el-option
                  v-for="item in skinOps"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地址" v-if="!patientMore">
              <el-input
                :disabled="readonly"
                v-model="form.address"
                placeholder="请输入地址"
                type
                style="width:85%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
            <el-form-item label="籍贯" v-if="!patientMore">
              <el-input
                :disabled="readonly"
                v-model="form.nativePlace"
                placeholder="请输入籍贯"
                type
                style="width:85%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
            <el-form-item label="国别" v-if="!patientMore">
              <el-input
                :disabled="readonly"
                v-model="form.country"
                placeholder="请输入国别"
                type
                style="width:85%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
            <el-form-item label="职业" v-if="!patientMore">
              <el-input
                :disabled="readonly"
                v-model="form.profession"
                placeholder="请输入职业"
                type
                style="width:85%;"
                v-if="!patientMore"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮件" v-if="!patientMore" prop="email">
              <el-input
                :disabled="readonly"
                v-model="form.email"
                placeholder="请输入电子邮件"
                type
                style="width:85%;"
                @blur="patientForm"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="moreBtn" v-if="patientMore" style="width:88%;margin-bottom:10px;">
            <!--<button
              class="btn iconfont"
              @click="showPatientMore('show')"
              style="padding: 0"
            >&#xe7fe;</button>-->
            <div class="show-more-text" @click="showPatientMore('show')">更多</div>
            <div class="iconfont show-more-btn" @click="showPatientMore('show')">&#xe7fe;</div>
          </div>
        </div>
      </div>
      <!--检查信息相关html-->
      <div class="check-info">
        <div class="c-header">
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-jianchaxinxi"></i>
          <span id="fontF">相关信息</span>
        </div>
        <div class="c-content">
          <el-form
            :model="form2"
            size="mini"
            status-icon
            :rules="checkRules"
            style="width:95%"
            v-if="isShowStateIcon"
            label-width="80px"
            label-position="left"
          >
            <!--<el-form-item label="检查编号*" prop="id_in_hospital">
<el-input v-model="form2.id_in_hospital" style="width: 100%;" :disabled="hospital_id_disabled"
          :readonly="fromDetailDiagnose" placeholder="请输入检查编号" @blur="checkDiagnosis"></el-input>
            </el-form-item>-->
            <el-form-item label="费别**" prop="fee_type">
              <el-select
                v-model="operationDiagnoses.fee_type"
                size="small"
                @blur="patientForm"
                @change="feeChange()"
              >
                <el-option
                  v-for="item in operationFee"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="诊断" prop="initial_conclusion">
              <el-autocomplete
                style="width: 100%;"
                class="popInput"
                v-model="operationDiagnoses.diagnosis_template"
                :fetch-suggestions="queryDisease"
                placeholder="选择诊断结果"
                :trigger-on-focus="false"
                @select="chooseDisease"
                @input="updateInput"
                @blur="addRelevantInfomation2"
                @focus="inputFocus"
                size="small"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item label="主诉">
              <el-input
                v-model="operationDiagnoses.main_suit"
                style="width: 100%;"
                placeholder="不得超过512个字"
                :readonly="fromDetailDiagnose"
                type="textarea"
                @blur="addRelevantInfomation"
                :maxlength="textAreaMaxLen"
                @focus="inputFocus"
              ></el-input>
            </el-form-item>
            <el-form-item label="既往史">
              <el-input
                v-model="operationDiagnoses.past_history"
                style="width: 100%;"
                placeholder="不得超过512个字"
                :readonly="fromDetailDiagnose"
                type="textarea"
                @blur="addRelevantInfomation"
                :maxlength="textAreaMaxLen"
                @focus="inputFocus"
              ></el-input>
            </el-form-item>
            <el-form-item label="住院号" prop="id_in_hospital">
              <el-input
                v-model="operationDiagnoses.id_in_hospital"
                style="width: 100%;"
                :readonly="fromDetailDiagnose"
                placeholder="请输入"
                @blur="addRelevantInfomation"
                @focus="inputFocus"
              ></el-input>
            </el-form-item>
            <el-form-item label="床号" prop="id_in_hospital">
              <el-input
                v-model="operationDiagnoses.id_bed"
                style="width: 100%;"
                :readonly="fromDetailDiagnose"
                placeholder="请输入"
                @focus="inputFocus"
                @blur="addRelevantInfomation"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import intelligent from "../utils/inteligent";
import addOperationReleInfo from "../gql/addOperationReleInfo.gql";
import setOperationReleInfo from "../gql/setOperationReleInfo.gql";
import getRelevantByOperation from "../gql/getRelevantByOperation.gql";
import getPatientsByOperation from "../gql/getPatientsByOperation.gql";
import getPatientsLastInfo from "../gql/getPatientsLastInfo.gql";
import knowledgeDicTemplate from "../utils/knowledgeDicTemplate.js";
import moment from "moment";
import gql from "graphql-tag";
let time = null;
export default {
  data() {
    return {
      operationFee: [{ value: "医保", index: 0 }, { value: "自费", index: 1 }],
      operationDiagnoses: {
        fee_type: "医保",
        diagnosis_template: "",
        main_suit: "",
        past_history: "",
        id_in_hospital: "",
        id_bed: ""
      },
      isChangeRelevantInfo: false,
      isMutationInfo: false,
      relevantInfoId: "",
      diagnosis_template_id: ""
    };
  },
  mixins: [intelligent, knowledgeDicTemplate],
  computed: {
    opearClick() {
      return this.$store.state.operationClearClick;
    },
    operationRelevantId() {
      return this.$store.state.operationRelevantId;
    },
    editOperation() {
      return this.$store.state.editOperation;
    },
    operationElectiveId() {
      return Number(this.$store.state.operationElectiveId);
    },
    operationPatientId() {
      return Number(this.$store.state.operationPatientId);
    }
  },
  watch: {
    async "operationDiagnoses.diagnosis_template"(newVal) {
      
      if (!newVal && !this.editOperation) {
        this.diagnosis_template_id = "";
        await this.addRelevantInfomation();
      }
      this.$store.commit(
        "setoperationPrintDiagnoses",
        this.operationDiagnoses.diagnosis_template
      );
    },
    'diagnosis_template_id'(newVal) {
      if (newVal) {
        this.$store.commit(
          "setoperationPrintDiagnoses",
          this.operationDiagnoses.diagnosis_template
        );
      }
    },
    'opearClick'(newVal) {
      if (newVal) {
        this.reset();
      }
    },
    async 'patient_id'(newVal) {
      this.$store.commit("setoperationPatientId", newVal);
      if (newVal) {
        if (!this.editOperation) {
          await this.getLastInfo();
          await this.mutateRelevantInfomation();
        }
      }
    },
    'relevantInfoId'(newVal) {
      this.$store.commit("setoperationRelevantId", newVal);
    },

    'operationDiagnoses': {
      handler(newVal, oldVal) {
        this.isChangeRelevantInfo = true;
      },
      immediate: false,
      deep: true
    },
    "operationDiagnoses.id_in_hospital"(newVal) {
      this.$store.commit("setoperationPrintInHospitaiNum", newVal);
    }
  },
  async mounted() {
    await this.getKnowledgeDic();
    await this.queryMyTemplate();
    if (this.opearClick) {
      await this.reset();
    }
    if (this.patient_id) {
      // 不是编辑时跳入该页面时，做关联查询
      if (!this.editOperation) {
        await this.getLastInfo();
        await this.mutateRelevantInfomation();
      }
    }
  },
  beforeDestroy() {
    this.$store.commit("setoperationElectiveId", "");
    this.$store.commit("setoperationRelevantId", "");
  },
  methods: {
    inputFocus() {

      this.$store.commit("setoperationInput", true);
    },
    updateInput(e) {
      this.$forceUpdate();
    },
    async chooseDisease(item) {
      clearTimeout(time);
      this.diagnosis_template_id = item.id;
      this.$store.commit("setoperationPrintDiagnoses", item.value);
      this.isChangeRelevantInfo = true;
      await this.addRelevantInfomation();
    },
    async reset() {
      this.form = {
        id: "",
        // 患者id
        id_in_hospital: "",
        // 姓名
        name: "",
        birthday: "",
        age: "",
        skin_color: "",
        skin_type:"",
        gender: "男",
        phone: "",
        // 民族
        race: "",
        // 地址
        address: "",
        // 身份证号
        idCardNumber: "",
        // 籍贯
        nativePlace: "",
        country: "",
        // 职业
        profession: "",
        email: "",
        created_time: ""
      };
      this.operationDiagnoses = {
        fee_type: "医保",
        diagnosis_template: "",
        main_suit: "",
        past_history: "",
        id_in_hospital: "",
        id_bed: ""
      };
      this.$store.commit("setoperationPrintInHospitaiNum", "");
      this.$store.commit("setoperationPrintDiagnoses", "");
      this.patient_id = "";
      this.relevantInfoId = "";
      this.diagnosis_template_id = "";
      this.readonly = false;
      this.isChangeRelevantInfo = false;
      this.isMutationInfo = false;
      this.$store.commit("setoperationFormPatientStatus", true);
      this.$store.commit("setoperationFormRelevantStatus", true);
      this.$store.commit("setoperationInput", false);
      if (this.operationElectiveId && this.editOperation) {
        this.relevantInfoId = this.operationRelevantId;
        this.patient_id = this.operationPatientId;
        await this.getRelevantInfo();
        await this.getPatientsDatas();
      } else {
        this.$store.commit("setoperationElectiveId", "");
        this.$store.commit("setoperationRelevantId", "");
      }
    },
    setPatientsForm() {
      // this.useID = true;
      // this.isReset = true;
      this.readonly = true;
      // this.fromNewDiagnose = true;
      // this.patient_id = item.id;
      // 重置form表单验证状态
      // this.$refs.form.resetFields();
    },
    async getLastInfo() {
      // 查询相关信息的最新值，并做填充
      try {
        let res = await this.$apollo.query({
          query: getPatientsLastInfo,
          variables: {
            id: this.patient_id
          },
          fetchPolicy: "no-cache"
        });
        let newData = res.data.patient;
        this.operationDiagnoses.diagnosis_template = this.formatConclusion(
          newData.last_diagnosis_text
        );
        this.diagnosis_template_id = newData.last_diagnosis_text;
        this.operationDiagnoses.past_history = newData.last_past_history;
        this.operationDiagnoses.main_suit = newData.last_main_suit;
        this.operationDiagnoses.id_in_hospital = newData.last_id_inhospital;
      } catch (error) {
        console.log(error);
      }
    },
    async getPatientsDatas() {
      try {
        let res = await this.$apollo.query({
          query: getPatientsByOperation,
          variables: {
            id: this.operationElectiveId
          },
          fetchPolicy: "no-cache"
        });
       
        let params = res.data.operation.patient_info[0];
        this.form.id = params.id;
        this.form.created_time = params.created_time;
        this.form.id_in_hospital = params.id_in_hospital;
        this.form.birthday =
          params.birthday === this.initialTime
            ? ""
            : moment(params.birthday).format("YYYY-MM-DD");
        this.form.age = params.age > -1 ? params.age + "" : "";
        this.form.id_card_number = params.id_card_number;
        this.form.phone = params.phone;
        this.form.profession = params.profession;
        this.form.gender = params.gender;
        this.form.name = params.name;
        this.form.race = params.race;
        this.form.skin_color = params.skin_color;
        this.form.skin_type = params.skin_type;
        this.form.address = params.address;
        this.form.idCardNumber = params.id_card_number;
        this.form.nativePlace = params.native_place;
        this.form.country = params.country;
        this.form.email = params.email;
        this.setPatientsForm();
      } catch (error) {
        console.log(error);
      }
    },
    async getRelevantInfo() {
      try {
        let res = await this.$apollo.query({
          query: getRelevantByOperation,
          variables: {
            id: this.operationElectiveId
          },
          fetchPolicy: "no-cache"
        });
        let newData = res.data.operation.relevant_info[0];

        this.operationDiagnoses = newData;
        this.operationDiagnoses.diagnosis_template = this.formatConclusion(
          newData.diagnosis
        );
        this.diagnosis_template_id = this.formatConclusion2(newData.diagnosis);
     
      } catch (error) {
        console.log(error);
      }
    },
    clearOperation() {
      // this.newPatient()
      if (!this.opearClick) {
        this.patient_id_disabled = false;
        this.fromNewDiagnose = false;
        this.$store.commit("setoperationClearClick", true);
      }
      this.$store.commit("seteditOperation", false);
      this.patientMore = true;
    },
    async feeChange() {
      await this.setRelevantInfomation();
    },
    addRelevantInfomation2() {
      this.$store.commit(
        "setoperationPrintDiagnoses",
        this.operationDiagnoses.diagnosis_template
      );
      // 取消上次延时未执行的方法
      clearTimeout(time);
      // 执行延时
      time = setTimeout(async () => {
        // do function在此处写单击事件要执行的代码
        let newName = this.queryTemplatesByName(
          this.operationDiagnoses.diagnosis_template
        );
        if (_.isEmpty(newName)) {
          this.diagnosis_template_id = "";
        }
        await this.addRelevantInfomation();
      }, 300);
    },
    async addRelevantInfomation() {
      // if (this.isChangeRelevantInfo) {
      if (this.patient_id) {
        if (this.relevantInfoId) {
          await this.setRelevantInfomation();
        } else {
          await this.mutateRelevantInfomation();
        }
      } else {
        this.$message.error("请填写患者信息");
      }
      // }
    },
    async mutateRelevantInfomation() {
      try {
        if (!this.$store.state.doctorDitail.id) {
          await this.getMe();
        }
        let res = await this.$apollo.mutate({
          mutation: addOperationReleInfo,
          variables: {
            fee_type: this.operationDiagnoses.fee_type,
            diagnosis: this.operationDiagnoses.diagnosis_template,
            main_suit: this.operationDiagnoses.main_suit,
            past_history: this.operationDiagnoses.past_history,
            id_in_hospital: this.operationDiagnoses.id_in_hospital,
            id_bed: this.operationDiagnoses.id_bed,
            doctor_id: Number(this.$store.state.doctorDitail.id),
            patient_id: Number(this.patient_id),
            diagnosis_value: this.$store.state.operationPrintDiagnoses
          }
        });
        this.relevantInfoId = res.data.addOperationReleInfo.id;
        this.$message.success("相关信息已创建");
        this.isMutationInfo = true;
        this.isChangeRelevantInfo = false;
      } catch (error) {
        this.$message.error("请重试");
        this.operationDiagnoses = {
          fee_type: "医保",
          diagnosis: "",
          main_suit: "",
          past_history: "",
          id_in_hospital: "",
          id_bed: ""
        };
        this.isChangeRelevantInfo = false;
      }
    },
    async getMe() {
      try {
        let res = await this.$apollo.query({
          query: gql`
            {
              me {
                id
                realname
              }
            }
          `
        });
        let realname = res.data.me.realname;
        this.$store.commit("setMe", realname);
        localStorage.setItem("me", realname);
        this.$store.commit("setdoctorDitail", {
          id: res.data.me.id,
          realname: res.data.me.realname ? res.data.me.realname : ""
        });
      } catch (error) {
        this.$message.error("请检查网络后重试");
      }
    },
    async setRelevantInfomation() {
      try {
        if (!this.$store.state.doctorDitail.id) {
          await this.getMe();
        }
        await this.$apollo.mutate({
          mutation: setOperationReleInfo,
          variables: {
            id: Number(this.relevantInfoId),
            fee_type: this.operationDiagnoses.fee_type,
            diagnosis: this.operationDiagnoses.diagnosis_template,
            main_suit: this.operationDiagnoses.main_suit,
            past_history: this.operationDiagnoses.past_history,
            id_in_hospital: this.operationDiagnoses.id_in_hospital,
            id_bed: this.operationDiagnoses.id_bed,
            doctor_id: Number(this.$store.state.doctorDitail.id),
            patient_id: Number(this.patient_id),
            diagnosis_value: this.$store.state.operationPrintDiagnoses
          }
        });
        this.$message.success("相关信息已保存");
        this.$store.commit("setoperationInput", false);

    

        this.isMutationInfo = true;
        this.isChangeRelevantInfo = false;
        this.$root.$emit("refreshOperationList");
      } catch (error) {
        this.$store.commit("setoperationInput", false);
        this.$message.error("请检查网络后重试");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.patient-wrapper,
.imgWrapper .chooseImgCon .sex-con,
.race-con,
.date-wrapper,
.summary,
.btns,
.img-list-con,
.img-list,
.row-con,
.img-item,
.rightRadio,
.line-sesu,
.right-img-con,
.CTetc-con,
.top-nav,
.left-row,
.right-row,
.bottom-wrapper,
.head-con,
.head-nav,
.img-con,
.report-con,
.choosedFigureCon,
.imgWrapper,
.imgRes {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.imgRes {
  width: 98%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #61a2bf;
  padding: 10px;
  font-size: 16px;
  color: #61a2bf;
  border-radius: 6px;
  margin-right: 1%;

  .imgResLine {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    .inline-input {
      ::-webkit-input-placeholder {
        text-align: center;
      }
    }
  }
}

/*::-webkit-scrollbar {*/
/*width: 5px;*/
/*height: 100%;*/
/*}*/

/*::-webkit-scrollbar-track-piece {*/
/*background: #fff;*/
/*-webkit-border-radius: 6px;*/
/*}*/

/*::-webkit-scrollbar-thumb:vertical {*/
/*background-color: #61a2bf;*/
/*-webkit-border-radius: 6px;*/
/*}*/

.similarDialog {
  .el-dialog--center {
    background: #ebebeb;
    border-radius: 10px;
  }
}

.imgWrapper {
  align-items: flex-start;
  justify-content: space-between;
  font-size: 1.5rem;
  margin-top: 5vh;
  color: #48a3c2;

  .chooseImgCon {
    flex: 1;
    text-align: center;
    margin-right: 2%;

    .cs-text {
      margin-bottom: 2vh;
    }
  }

  .chooseImgCon:nth-child(2) {
    margin-right: 0px;
  }
}

.race-con {
  margin-left: 19%;

  #input-box_1 {
    display: flex;
  }
}

.choosedFigureCon {
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;

  .choosedFigureItem {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    // margin-right: 2rem;
    justify-content: space-between;
    width: 70%;
    background: #fff;
    text-align: center;
    padding: 2px 0px;
    padding-left: 10px;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.checkPositionCon {
  display: flex;
  align-items: center;
}

.topLevelCon {
  position: absolute;
  width: 50%;
  left: 15%;
  top: -15rem;
  // height: 300px;
  background: #fff;
  display: flex;
  z-index: 100;
  flex-direction: column;

  .topLevelItem {
    padding: 5px 1%;
    width: 100%;
    height: 20px;
    position: relative;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
    font-size: 14px;
    border-right: 1px solid #f2f2f2;

    .secondLevelCon {
      position: absolute;
      width: 96%;
      height: 186px;
      left: 100%;
      background: #fff;
      overflow-y: auto;
      border-left: 1px solid #f2f2f2;

      .secondLevelItem {
        width: 96%;
        padding: 5px 1%;
        height: 20px;
        border-bottom: 1px solid #f2f2f2;
        border-left: 1px solid #f2f2f2;

        white-space: nowrap;
        cursor: pointer;
        font-size: 14px;
      }
    }
  }
}

.moreBtn {
  position: relative;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  .moreButton {
    width: 20%;
    height: 20px;
    background: #61a2bf;
    color: #fff;
    cursor: pointer;
    padding: 5px 30px;
    line-height: 20px;
    border-radius: 5px;
    font-size: 15px;
    text-align: center;
  }
}

.addPatientBtn {
  width: 10%;
  display: flex;
  justify-content: center;
  height: 20px;
  background: #e9af3f;
  color: #fff;
  cursor: pointer;
  padding: 5px 10%;
  line-height: 20px;
  border-radius: 5px;
  font-size: 15px;
  text-align: center;
  white-space: nowrap;
}

.mask {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.camera-con {
  width: 52%;
  position: fixed;
  left: 47%;
  border-radius: 15px;
  background: #ebebeb;
  outline: none;

  .booth {
    position: relative;

    .titleCon {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      margin-bottom: 0.6rem;
      margin-top: 1rem;

      .leftCon {
        display: flex;
        align-items: center;
        margin-left: 3rem;
        color: #7cafc7;
        font-size: 1.2rem;
      }

      .rightCon {
        /*margin-right: -40%;*/
      }
    }

    #canvas {
      position: absolute;
      left: 3rem;
      top: 4rem;
    }
  }
}

.imgWrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.chooseImgCon {
  flex-direction: column;
}

.imglist-con {
  width: 100%;
  height: 100%;
}

#div1 {
  border: 1px solid #ec0023;
  width: 100%;
  height: 200px;
}

.report-con {
  width: 100%;
  justify-content: space-between;
  margin-top: 30px;
}

.img-con {
  flex-wrap: wrap;
  width: 100%;

  .generalWrapper:nth-child(1) {
    margin-left: 1%;
  }
}

.CTetc-con {
  /*height: 67%;*/
  height: calc(~"100% - 225px");
  min-height: 500px;
  flex-direction: column;

  .page-con {
    height: 89%;
  }
}

.row-con {
  width: 98%;
  height: 20%;
  margin: 0 1%;
  align-items: center;

  .imgRes {
    height: 100%;
    padding: 1%;
    box-sizing: border-box;
    white-space: nowrap;
  }
}

.history-tabel {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 280px;

  .head {
    display: flex;
    align-items: center;
    height: 40px;
    color: rgb(97, 162, 191);
    margin: 0 10px;
    border-bottom: 2px solid rgb(97, 162, 191);
    box-sizing: border-box;

    .iconfont {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 35px;
      height: 35px;
      font-size: 26px;
    }
  }
}

.el-button {
  box-shadow: 3px 3px 10px grey;
}

.left-row {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid #48a3c2;
  border-radius: 10px;
  width: 50%;
  margin-right: 2%;
  height: 120px;
  align-items: flex-start;
  margin-left: 10px;
}

.right-row {
  width: 49%;
  height: 120px;
  align-items: flex-start;
  margin-right: 10px;
}

.img-list-con {
  width: 100%;
  justify-content: space-between;
}

.img-list {
  width: 90%;
}

.img-item {
  width: 25%;
  height: 94px;
  background: #f2f2f2;
  margin-right: 2%;
  box-shadow: 1px 1px 10px grey;
}

textarea::-webkit-input-placeholder {
  color: #61a2bf;
  font-size: 15px;
}

// .img-item:nth-child(1) {
// }

.img-item:nth-child(3) {
  margin-right: 0%;
}

.activeOption {
  color: #48a3c2;
  border: 1px solid #48a3c2;
  background: #f2f2f2;
}

.normalOption {
  background: #f2f2f2;
}

textarea {
  outline: none;
}

.summary {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 120px;
  border-top: 1px solid #48a3c2;
  width: 98%;
  margin-top: 10px;
}

.rightRadio {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 12%;
}

.top-nav {
  flex-direction: row;
  justify-content: space-around;
  // flex-shrink: 2;
  width: 100%;
  /*height: 8.6%;*/
  height: 40px;

  .option-item {
    background: #dcdcdc;
    width: 19.7%;
    height: 100%;
    font-size: 16px;
    text-align: center;
    box-shadow: 2px 2px 10px grey;
    white-space: nowrap;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .option-item:nth-child(3) {
    margin-bottom: 0px;
  }
}

.right-img-con {
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  height: 300px;
  margin-left: -1.1%;
  margin-top: -5px;
  padding: 5px 5px;
  overflow-y: auto;
}

.line-sesu {
  margin-left: 4%;
}

.btns {
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .markAndGenerate {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-left: 13px;
    height: 100%;

    .collectBtn {
      height: 100%;
      cursor: pointer;
      display: flex;
      width: 92px;
      flex-direction: column;
      // height: 32px;
      line-height: 32px;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 5px;

      .btn-btn {
        height: 28px;
      }

      .print-btn {
        flex: 1;
        margin-bottom: 4px;
      }

      .download-btn {
        margin-bottom: 4px;
        flex: 1;
      }
    }
  }
}

.date-wrapper {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sex-con {
  display: flex;
  align-items: center;
  margin-right: 3%;
}

.label {
  font-size: 14px;
  color: #606266;
  margin-right: 6%;
  white-space: nowrap;
}

// .more-wrapper {
// }

.right-img-con {
  background: #f2f2f2;
}

p {
  margin: 0;
}

.intell-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}

.i-header,
.c-header {
  width: 88%;
  color: #48a3c2;
  font-size: 16px;
  border-bottom: 2px solid #48a3c2;
  padding: 5px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  height: 25px;
  text-align: left;
  display: flex;
  align-items: center;
}

.patient-header {
  display: flex;
  justify-content: space-between;
}

.c-content {
  padding-right: 7%;
  text-align: right;
  // overflow-x: hidden;
  // overflow-y: hidden;
  height: 50%;
}

// @media screen and(min-width: 1920px) {
//   .intell-box{
//     .intell-right{
//       width: 80%;
//     }
//   }
// }
.intell-left {
  width: 330px;
  min-width: 300px;
  height: 100%;
  background: #eff3f7;
  float: left;
  padding: 5px 0px;
  padding-left: 6px;
  overflow: hidden;
  // overflow-y: auto;
}

.intell-right {
  overflow-y: hidden;
  padding-right: 1px;
  min-width: 850px;
  height: 100%;
  float: left;
  display: flex;
  flex: 1;
  flex-direction: row;
  margin-left: 4px;

  .left-content {
    width: 100%;
    height: 100%;
  }
}

.right-knowledge {
  position: relative;
  background: #eff3f7;
  width: 302px;
  min-width: 253px;
  overflow-y: auto;
  margin-left: 4px;

  .detailed-l {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 280px;
    padding: 1%;

    .tree-content {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 46px;
      padding-left: 7%;
      padding-right: 7%;
    }

    .detailed-head {
      color: #61a2bf;
      width: 86%;
      margin-left: 7%;
      padding-bottom: 6px;
      border-bottom: 2px solid #61a2bf;
      display: flex;
      align-items: center;
    }
  }
}

.patient-info {
  width: 100%;
  overflow: hidden;
}

.check-info {
  width: 100%;
  padding-bottom: 30px;
}

.intell-r-t,
.intell-r-c,
.intell-r-b {
  overflow: hidden;
}

.intell-r-t {
  width: 100%;
  height: 100%;
}

.text-header {
  margin-top: 5px;
  margin-left: 5px;
}

.intell-r-c {
  height: 56%;
  width: 100%;
  overflow: hidden;
}

.btn-wrapper,
.i-header,
.p-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
}

.i-header {
  /*height: 2.8%;*/
  height: 29px;
  font-size: 17px;
}

.p-header {
  justify-content: flex-start;
}

.btn-wrapper {
  justify-content: space-around;
}

.img-l {
  width: 100%;
  height: 100%;
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: center;
}

.upload {
  position: absolute;
  bottom: 10px;
  right: 70px;
  z-index: 999;
}

.img-r {
  width: 60%;
  float: left;
  height: 100%;
}

.img-btn {
  float: right;
}

.img-list {
  width: 93%;
  height: 270px;
  overflow-x: hidden;
  overflow-y: auto;
}

.img-list .img-box {
  width: 122px;
  height: 92px;
  margin: 5px;
  float: left;
}

.img-box img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.img-box {
  position: relative;
}

.img-box2 {
  width: 100px;
  height: 86px;
  position: relative;
  margin: 5px;
  float: left;
  background-color: black;
}

.mirror-type {
  width: 50px;
  height: 15px;
  text-align: center;
  background: #fff;
  z-index: 100;
  position: absolute;
  bottom: 1px;
  left: 1px;
  border-radius: 5px;
  color: #48a3c2;
  font-size: 12px;
}

.edit-btn2 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 86px;
  text-align: center;
}

.edit-btn {
  width: 80x;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 20px;
  text-align: center;
}

.mycanvas {
  display: none;
}

.diagnosis-info {
  width: 630px;
  height: 86%;
  border: 1px solid #48a3c2;
  border-radius: 10px;
  float: left;
  margin-right: 10px;
  padding: 10px;
  box-sizing: border-box;
}

.detailed-info {
  width: 303px;
  height: 100%;
  float: left;
}

.detailed-top {
  width: 100%;
  height: 100%;
  border: 1px solid #48a3c2;
  border-radius: 10px;
  margin-bottom: 3px;
  padding: 10px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;
}

.detailed-bottom {
  width: 100%;
  height: 77.5px;
  border: 1px solid #48a3c2;
  border-radius: 10px;
}

.report-img {
  width: 90%;
  height: 28%;
  border: 1px solid #48a3c2;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}

.report-img img {
  width: 100px;
  height: 80px;
  margin: 5px;
}

.report-img p {
  margin: 0;
}

.img-desc {
  width: 90%;
  height: 28%;
  border: 1px solid #48a3c2;
  border-radius: 10px;
  margin-right: 10px;
  padding: 10px;
  overflow: hidden;
}

.img-desc textarea {
  border: none;
  outline: none;
  resize: none;
}

.img-desc textarea:focus {
  border: none;
}

.img-desc p {
  margin: 0;
}

.intell-btn {
  width: 100%;
  height: 150px;
}

.intell-btn button {
  width: 90px;
  margin: 10px 5px;
}

// .editorImg-enter-active,
// .fade-leave-active {
// }

.editorImg-enter,
.editorImg-leave-to {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.edit-container {
  z-index: 999;
}

.edit-box {
  background: #ebebeb;
  border-radius: 20px;
  width: 72vw;
  height: 86vh;
  position: fixed;
  top: 6vh;
  left: 13vw;
  z-index: 999;
  padding: 20px;
  // padding-top: 50px;
  box-sizing: border-box;
}

.resilts {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.print-content {
  width: 100%;
  height: 100%;
  z-index: 999;
  position: fixed;
  // display: none;
  overflow-y: auto;
  top: 0;
  left: 0;
}

.detailed-bottom {
  padding: 10px;
  text-align: center;
  box-sizing: border-box;
}

.el-form-item {
  margin-bottom: 10px;
}

.result-img {
  width: 86px;
  height: 65px;
  float: left;
  margin: 5px 1px;
}

.result-img img {
  width: 100%;
  height: 100%;
}

.el-autocomplete-suggestion li.highlighted,
.el-autocomplete-suggestion li:hover {
  background-color: #116cf5;
}

.big-img {
  width: 50%;
  height: 80%;
  margin-top: 5%;
  margin: 0 auto;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #000;
  box-sizing: border-box;
  position: fixed;
  top: 5%;
  left: 25%;
  z-index: 999;
}

.big-img h1 {
  font-size: 24px;
  text-align: center;
  margin: 10px 0;
  position: relative;
}

.big-img h1 i {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 10px;
}

.big-img-content {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.myswiper-pagination {
  text-align: center;
}

.myswiper-pagination span {
  margin: 0 10px;
}

@media screen and (max-width: 1366px) {
  .intell-box {
    .intell-left {
      min-width: 320px;
      width: 320px;
    }

    .intell-right {
      min-width: 683px;
    }

    .right-knowledge {
      min-width: 260px;
      width: 260px;
    }
  }
}

.el-dialog--center .el-dialog__body {
  padding: 0 !important;
}

.el-dialog__body {
  padding: 0 !important;
}

.intell-left-content {
  height: calc(~"100% - 42px") !important;
  overflow: auto !important;
}

.show-more-text {
  color: rgb(97, 162, 191);
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
}
.show-more-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(97, 162, 191);
  font-size: 19px;
  cursor: pointer;
}
</style>
